import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@Component({
  selector: 'app-processing-boundary',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './processing-boundary.component.html',
  styleUrls: ['./processing-boundary.component.scss'],
})
export class ProcessingBoundaryComponent implements OnInit {
  @Input() isProcessing = false;
  @Input() spinnerDiameter = 50;
  @Input() showEmptyResultMsg = false;
  @Input() emptyResultMsg = 'No results to display.';
  @Input() processingMsg: string;
  @Input() secondaryProcessingMsg: string;
  @Input() cssStyles: { [key: string]: string };
  @Input() cssClasses: string[];

  constructor() {}

  ngOnInit(): void {}
}
